// src/constants/config.js
import {
  BRAND_DESCRIPTION,
  BRAND_NAME,
  BRAND_OG_DESCRIPTION,
  BRAND_SITE_TITLE,
  BRAND_SITE_URL,
  BRAND_SUPPORT_EMAIL,
  BRAND_TAGLINE,
  BRAND_TITLE,
} from "./brand";

export const PRODUCT_NAME = BRAND_NAME;
export const PRODUCT_NAME_TITLE = BRAND_TITLE;
export const PRODUCT_TAGLINE = BRAND_TAGLINE;
export const PRODUCT_SITE_TITLE = BRAND_SITE_TITLE;
export const PRODUCT_DESCRIPTION = BRAND_DESCRIPTION;
export const PRODUCT_OG_DESCRIPTION = BRAND_OG_DESCRIPTION;
export const PRODUCT_SUPPORT_EMAIL = BRAND_SUPPORT_EMAIL;
export const PRODUCT_SITE_URL = BRAND_SITE_URL;

export const CARE_LANGUAGE_LABELS = Object.freeze({
  careKnowledge: 'Care notes',
  careKnowledgeUpdated: 'Care notes updated',
  careKnowledgeSaving: 'Saving what Lifelog noticed',
  careKnowledgeFiled: 'Saved for later reference. Timeline moments stay on the day they happened.',
  careKnowledgeReviewSaved: 'Review saved care details',
  goalsToTrack: 'Goals found',
  goalSaved: 'Added to goals',
  goalSavedDestinations: 'Saved to Profile',
  goalView: 'View goal',
});
